module.exports = __webpack_public_path__ + "img/CHOOSE-BY-BASE-TYPE1@2x.db3f59ed.png";